export const ViewerGTMEvents = {
  initedEvent: 'initedEvent',
  loadedEvent: 'loadedEvent',
  timestampEvent: 'timestampEvent',
  materialColorChangedEvent: 'materialColorChangedEvent',
  diamondCutChangedEvent: 'diamondCutChangedEvent',
  pointOfViewChangedEvent: 'pointOfViewChangedEvent',
  rotateEvent: 'rotateEvent',
  zoomEvent: 'zoomEvent',
  averageFpsMetricEvent: 'averageFpsMetricEvent',
} as const

type ViewerGTMVariables = {
  loadTimeSec: number
  jewelryId: string
  dateTimeString: string
  materialColorDescription: string
  diamondCutDescription: string
  povDescription: string
  averageFps: number
}

export type ViewerBaseGTMEvent = {
  event: keyof typeof ViewerGTMEvents
}

export type ViewerInitedEvent = ViewerBaseGTMEvent & {
  event: typeof ViewerGTMEvents.initedEvent
} & Pick<ViewerGTMVariables, 'jewelryId'>

export type ViewerTimeStampEvent = ViewerBaseGTMEvent & {
  event: typeof ViewerGTMEvents.timestampEvent
} & Pick<ViewerGTMVariables, 'dateTimeString'>

export type ViewerLoadedEvent = ViewerBaseGTMEvent & {
  event: typeof ViewerGTMEvents.loadedEvent
} & Pick<ViewerGTMVariables, 'loadTimeSec'>

export type ViewerMaterialColorChangedEvent = ViewerBaseGTMEvent & {
  event: typeof ViewerGTMEvents.materialColorChangedEvent
} & Pick<ViewerGTMVariables, 'materialColorDescription'>

export type ViewerDiamondCutChangedEvent = ViewerBaseGTMEvent & {
  event: typeof ViewerGTMEvents.diamondCutChangedEvent
} & Pick<ViewerGTMVariables, 'diamondCutDescription'>

export type ViewerPointOfViewChangedEvent = ViewerBaseGTMEvent & {
  event: typeof ViewerGTMEvents.pointOfViewChangedEvent
} & Pick<ViewerGTMVariables, 'povDescription'>

export type ViewerRotateEvent = ViewerBaseGTMEvent & {
  event: typeof ViewerGTMEvents.rotateEvent
}

export type ViewerZoomEvent = ViewerBaseGTMEvent & {
  event: typeof ViewerGTMEvents.zoomEvent
}

export type ViewerAverageFpsMetricEvent = ViewerBaseGTMEvent & {
  event: typeof ViewerGTMEvents.averageFpsMetricEvent
} & Pick<ViewerGTMVariables, 'averageFps'>
